export interface Private_Material {
  Id: string;
  Code: string;
  Description: string;
  Status: Status;
}

export interface Material {
  id: string;
  code: string;
  description: string;
  status: Status;
}

export class Material {
  get isUnknown() {
    return !this.code || this.code === 'UNK' || this.code === 'UNK-NL';
  }
}

enum Status {
  Lead = 'Lead',
  LeadStatusUnknown = 'Lead Status Unknown',
  NonLead = 'Non-Lead',
}
